export default __webpack_public_path__ + "static/media/c1.82cd13ef.jpg";